import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { Container as i, ContentWrapper as m } from "./style.js";
const c = ({
  content: n,
  header: e,
  className: t
}) => /* @__PURE__ */ o(i, { className: t, children: [
  /* @__PURE__ */ r("div", { children: e }),
  /* @__PURE__ */ r(m, { children: n })
] });
export {
  c as BaseCommentContent
};
